// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"a2a13e7f","110":"f86976b7","374":"ac8c506d","409":"5b2ce29e","468":"b94a4d63","739":"7e3145a7","771":"a79056bd","791":"11be129d","871":"652bc7c3"}[chunkId] + ".chunk.js";
};